import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { sendCampaign } from "src/store/subscriptions/saga";
import * as Yup from "yup";

const CampaignForm = ({
  open,
  onHide,
  onSuccessClick,
}: {
  open: boolean;
  onHide: () => void;
  onSuccessClick: (message: string) => void;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const audience = [
    { EnumId: 1, Name: t("Subscriptions.AudienceAll") },
    { EnumId: 2, Name: t("Subscriptions.AudienceMembers") },
    { EnumId: 3, Name: t("Subscriptions.AudienceNonMembers") },
  ];

  return (
    <FormDrawer
      drawerProps={{ isOpen: open, onHide, title: t("Subscriptions.CampaignTitle").toString() }}
      onHide={onHide}
      loader
      initialValues={{ Subject: "", Preheader: "", AudienceId: 1, HtmlBody: "" }}
      validationSchema={Yup.object().shape({
        Subject: Yup.string().required(t("Validation.Required").toString()),
        HtmlBody: Yup.string().required(t("Validation.Required").toString()),
      })}
      onSubmit={(values) => {
        dispatch(
          sendCampaign({
            payload: {
              onSuccess: (message: string) => {
                onHide();
                onSuccessClick(message);
              },
              onError: (message: string) => toast.error(message, { theme: "colored" }),
            },
            body: values,
          })
        );
      }}
      inputs={[
        { field: "Subject", label: t("Subscriptions.Subject").toString() },
        { field: "Preheader", label: t("Subscriptions.Preheader").toString() },
        {
          field: "AudienceId",
          label: t("Subscriptions.Audience").toString(),
          type: "select",
          lookup: { labelKey: "Name", valueKey: "EnumId", options: audience },
        },
        { field: "HtmlBody", label: t("Subscriptions.Body").toString(), isEditor: true },
      ]}
    />
  );
};
export default CampaignForm;
